import type { RouteLocationNormalized, RouteLocationRaw } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";
import { ViewType } from "@ui/ui/nav/ViewType";

import type { SSchuelerAllgemeinesGruppenprozesseProps } from "~/components/schueler/allgemeines/SSchuelerAllgemeinesGruppenprozesseProps";
import { api } from "~/router/Api";
import { type RouteSchueler, routeSchueler } from "~/router/apps/schueler/RouteSchueler";
import { RouteNode } from "~/router/RouteNode";

const SSchuelerAllgemeinesGruppenprozesse = () => import("~/components/schueler/allgemeines/SSchuelerAllgemeinesGruppenprozesse.vue");


export class RouteSchuelerAllgemeinesGruppenprozesse extends RouteNode<any, RouteSchueler> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.KEINE], "schueler.gruppenprozesse.allgemeines", "gruppenprozesse/allgemeines", SSchuelerAllgemeinesGruppenprozesse);
		super.types = new Set([ViewType.GRUPPENPROZESSE]);
		super.mode = ServerMode.STABLE;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Allgemeines";
	}

	protected async update(): Promise<void | Error | RouteLocationRaw> {
		await routeSchueler.data.updateMapStundenplaene();
	}

	public getProps(to: RouteLocationNormalized): SSchuelerAllgemeinesGruppenprozesseProps {
		return {
			apiStatus: api.status,
			mapStundenplaene: routeSchueler.data.mapStundenplaene,
			schuelerListeManager: () => routeSchueler.data.manager,
			deleteSchueler: routeSchueler.data.delete,
			deleteSchuelerCheck: routeSchueler.data.deleteSchuelerCheck,
		};
	}

}

export const routeSchuelerAllgemeinesGruppenprozesse = new RouteSchuelerAllgemeinesGruppenprozesse();

